/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Alert, InputGroup, Button,
  NavItem, NavLink, Nav, TabPane, TabContent,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../helpers/api_helper';

function KitForm(props) {
  const {
    actionUrl,
    entity,
    t,
    user,
  } = props;

  const [, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [boxes, setBoxes] = useState([]);
  const isAdmin = Array.isArray(user?.roles)
    && user.roles.some((role) => ['Admin', 'Super Admin'].includes(role));

  useEffect(() => {
    let mounted = true;

    get('/api/inventory/boxes')
      .then((results) => {
        if (mounted) setBoxes(results);
      })
      .catch(() => {
        if (mounted) setBoxes([]);
      });

    return () => {
      mounted = false;
    };
  }, []);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(actionUrl, values);
      setErrorMessage(null);

      toastr.success(t(`Kit ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    stock_id: Yup.string().required(t('Stock ID is required')),
    image_url: Yup.string().nullable(),
    ship_weight: Yup.number().nullable(),
    ship_dims: Yup.string().nullable(),
    items: Yup.array().of(
      Yup.object().shape({
        stock_id: Yup.number().required(t('Stock ID is required')),
        sku: Yup.string().nullable(),
        qty: Yup.number().required(t('Quantity is required')),
      }),
    ),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, setFieldValue, values,
        }) => (
          <Form className="mt-3" id="KitEditForm" autoComplete="off">
            <Row>
              <Col md="3">
                <Nav pills className="flex-column">
                  <NavItem>
                    <NavLink
                      style={{ cursor: 'pointer' }}
                      className={classnames({
                        'mb-2': true,
                        active: activeTab === '1',
                      })}
                      onClick={() => {
                        setActiveTab('1');
                      }}
                    >
                      {props.t('General')}
                    </NavLink>
                  </NavItem>
                </Nav>

                {values.image_url && (
                  <img src={values.image_url} alt="thumbnail" className="rounded mt-3" style={{ maxHeight: '10rem', maxWidth: '10rem' }} />
                )}
              </Col>
              <Col md="9">
                <TabContent
                  activeTab={activeTab}
                  className="text-muted mt-md-0"
                >
                  <TabPane tabId="1">
                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="stock_id"
                            className="col-form-label"
                          >
                            {props.t('Stock ID')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.stock_id && touched.stock_id ? 'is-invalid' : '')}`}
                            id="stock_id"
                            name="stock_id"
                            onChange={(e) => {
                              setFieldValue('stock_id', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="stock_id"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>

                      <Col sm="6">
                        <div>
                          <Label
                            for="sku"
                            className="col-form-label"
                          >
                            {props.t('Sku')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.sku && touched.sku ? 'is-invalid' : '')}`}
                            id="sku"
                            name="sku"
                            onChange={(e) => {
                              setFieldValue('sku', e.target.value);
                            }}
                          />
                          <ErrorMessage
                            name="sku"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                        <small className="text-muted">
                          {t('Optional visual identifier')}
                        </small>
                      </Col>
                    </Row>

                    <div className="mb-3">
                      <Label
                        for="image_url"
                        className="col-form-label"
                      >
                        {props.t('Image URL')}
                      </Label>
                      <Field
                        type="text"
                        className={`form-control ${(errors.image_url && touched.image_url ? 'is-invalid' : '')}`}
                        id="iamge_url"
                        name="image_url"
                        onChange={(e) => {
                          setFieldValue('image_url', e.target.value);
                        }}
                      />
                      <ErrorMessage
                        name="image_url"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="mb-3">
                      <Label for="box_id" className="col-form-label">
                        {props.t('Box Size')}
                      </Label>
                      <Field
                        as="select"
                        className="form-select"
                        id="box_id"
                        name="box_id"
                        disabled={!isAdmin}
                        value={isAdmin && !values.box_id_locked ? '' : (values.box_id || '')}
                        onChange={(e) => {
                          const boxId = e.target.value === '' ? null : Number(e.target.value);
                          setFieldValue('box_id', boxId);
                          setFieldValue('box_id_locked', boxId !== null);
                        }}
                      >
                        <option value="">
                          {values.box_id && !values.box_id_locked
                            ? `${t('Automatic')} (${boxes.find((box) => Number(box.id) === Number(values.box_id))?.box_name || '-'})`
                            : t('Automatic')}
                        </option>
                        {boxes.map((box) => (
                          <option key={box.id} value={box.id}>{box.box_name}</option>
                        ))}
                      </Field>
                      {!isAdmin && (
                        <small className="text-muted">{t('Only Admin users can change the box size.')}</small>
                      )}
                    </div>

                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="ship_weight"
                            className="col-form-label"
                          >
                            {props.t('Default Ship Weight')}
                          </Label>
                          <InputGroup>
                            <Field
                              type="number"
                              step="0.01"
                              className={`form-control ${(errors.ship_weight && touched.ship_weight ? 'is-invalid' : '')}`}
                              id="ship_weight"
                              name="ship_weight"
                            />
                            <span className="input-group-text">LBS</span>
                          </InputGroup>
                          <ErrorMessage
                            name="ship_weight"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label
                            for="ship_dims"
                            className="col-form-label"
                          >
                            {props.t('Default Ship Dimensions')}
                          </Label>
                          <Field
                            type="text"
                            className={`form-control ${(errors.ship_dims && touched.ship_dims ? 'is-invalid' : '')}`}
                            id="ship_dims"
                            name="ship_dims"
                          />
                          <ErrorMessage
                            name="ship_dims"
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </Col>
                    </Row>

                    <h6 className="mt-4">{t('Items')}</h6>

                    <FieldArray name="items" className="mt-3">
                      {(arrayHelpers) => (
                        <>
                          <Button color="primary" size="sm" onClick={() => { arrayHelpers.push({ stock_id: '', qty: 1 }); }}>
                            <span className="mdi mdi-plus-thick" />
                          </Button>
                          {values.items.map((x, i) => (
                            <Row key={`item_${i}`} className="mt-2 mb-2">
                              <Col sm="7">
                                <div className="d-flex align-items-center" style={{ height: '5rem' }}>
                                  {values.items[i] !== undefined
                                    && values.items[i].inventory !== undefined
                                    && values.items[i].inventory !== null
                                    && values.items[i].inventory.id && (
                                    <img src={`/api/inventory/thumbnail/${values.items[i].inventory.id}`} alt="thumbnail" className="rounded me-4" style={{ maxHeight: '5rem', maxWidth: '5rem' }} />
                                  )}
                                  <div>
                                    {values.items[i] !== undefined
                                      && values.items[i].inventory !== undefined
                                      && values.items[i].inventory !== null
                                      && values.items[i].inventory.id && (
                                        <h6>{`${values.items[i].inventory.manufacturer} ${values.items[i].inventory.part_number}`}</h6>
                                    )}
                                    <InputGroup className="mt-2 mb-2">
                                      <Field
                                        className="form-control"
                                        name={`items[${i}].stock_id`}
                                        placeholder="Inventory Stock ID"
                                      />
                                      <Button color="danger" onClick={() => { arrayHelpers.remove(i); }}>
                                        <span className="mdi mdi-close-thick" />
                                      </Button>
                                    </InputGroup>
                                  </div>
                                </div>

                                <ErrorMessage
                                  name={`items[${i}].stock_id`}
                                  component="div"
                                  className="text-danger"
                                />
                              </Col>

                              <Col sm="5">
                                <div className="d-flex align-items-center" style={{ height: '5rem' }}>
                                  <div>
                                    <h6>{t('Quantity per kit')}</h6>
                                    <InputGroup className="mt-2 mb-2">
                                      <Field
                                        type="number"
                                        className="form-control"
                                        name={`items[${i}].qty`}
                                        placeholder="Quantity"
                                      />
                                    </InputGroup>
                                  </div>
                                </div>

                                <ErrorMessage
                                  name={`items[${i}].qty`}
                                  component="div"
                                  className="text-danger"
                                />
                              </Col>
                            </Row>
                          ))}
                        </>
                      )}
                    </FieldArray>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

KitForm.defaultProps = {
  entity: {
    stock_id: '', ship_weight: '', ship_dims: '', items: [],
  },
  onSuccess: () => {},
  user: { roles: [] },
};

KitForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
  user: PropTypes.object,
};

export default connect((state) => ({
  user: state.Login.user,
}), {})(withTranslation()(KitForm));
